"use client";

import { NativeLink as Link } from "@/components/native-link";
import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";

type SessionDetailToolbarProps = {
  backHref?: string;
  backLabel?: string;
  actions?: ReactNode;
};

export function SessionDetailToolbar({
  backHref = "/sessions",
  backLabel = "Back to sessions",
  actions,
}: SessionDetailToolbarProps) {
  return (
    <div className="session-detail-toolbar">
      <Link className="btn session-detail-back" href={backHref}>
        <ArrowLeft size={16} aria-hidden />
        {backLabel}
      </Link>
      {actions ? <div className="session-detail-toolbar-actions">{actions}</div> : null}
    </div>
  );
}
